module.exports = __webpack_public_path__ + "static/media/bglobe-logo-white.3b15d9fd.svg";